import { NgForOf, NgIf, NgStyle } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { TypographyComponent } from 'components';

export type ChartLegendOption = {
	title: string;
	color: string;
	value?: string;
};

@Component({
	standalone: true,
	selector: 'chart-legend',
	template: `
		<div class="points" *ngIf="options">
			<div class="point" *ngFor="let option of options">
				<div
					class="circle"
					[ngStyle]="{ '--circle-color': option.color }"
				></div>
				<typography variant="p/base_regular">
					{{ option.title
					}}{{ option.value != null ? ' - ' + option.value : '' }}
				</typography>
			</div>
		</div>
		<div
			class="title"
			*ngIf="chartTitle"
			[ngStyle]="{ width: options ? 'unset' : '100%' }"
		>
			<typography class="title">{{ chartTitle }}</typography>
		</div>
	`,
	imports: [NgForOf, NgStyle, TypographyComponent, NgIf],
	styles: [
		`
			:host {
				display: flex;
				justify-content: space-between;
				column-gap: 0.5rem;
				padding-top: 0.75rem;
				flex-direction: row;

				.points {
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					column-gap: 10px;

					.point {
						display: flex;
						align-items: center;
						column-gap: 0.25rem;

						.circle {
							--circle-color: initial;

							width: 0.5rem;
							height: 0.5rem;
							border-radius: 50%;
							background-color: var(--circle-color);
						}
					}

					typography {
						font-size: 0.75rem;
						font-style: normal;
						font-weight: 400;
						line-height: normal;
						color: #666;
					}
				}

				.title {
					display: flex;
					align-items: center;
					justify-content: center;

					typography {
						font-size: 0.75rem;
						font-style: normal;
						font-weight: 400;
						line-height: normal;
						color: #666;
					}
				}
			}
		`
	]
})
export class ChartLegendComponent {
	@Input() chartTitle: string = '';
	@Input() options?: ChartLegendOption[];
	@Input() reverse: boolean = false;

	@HostBinding('style.flex-direction')
	get flexDirection() {
		return this.reverse ? 'row-reverse' : 'row';
	}
}
